import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import he from './locales/he.json';
import ar from './locales/ar.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      he: { translation: he },
      ar: { translation: ar },
      en: { translation: en },
    },    
    fallbackLng: 'he',
    supportedLngs: ['he', 'ar'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
  });
  // Set Hebrew as default if no language is stored
  if (!localStorage.getItem('i18nextLng')) {
    i18n.changeLanguage('he');
  }  

export default i18n;
